import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  DDU: [],
};

const DDUSlice = createSlice({
  name: "DDU",
  initialState,
  reducers: {
    updateDDU: (state, action) => {
      const index = state.DDU.findIndex(
        (item) => item.country === action.payload.country
      );
      if (index !== -1) {
        state.DDU[index] = action.payload;
      } else {
        state.DDU.push(action.payload);
      }
    },
  },
});

export const { updateDDU } = DDUSlice.actions;

export default DDUSlice.reducer;
